// extracted by mini-css-extract-plugin
module.exports = {"defaultIconButton":"style_defaultIconButton__y-kMR","copyValue":"style_copyValue__3Pmtn"};